/* @flow */

import { type EtapasId } from './types';

export const ETAPA_ABERTO = 1;
export const ETAPA_PENDENTE = 2;
export const ETAPA_APROVADO = 3;
export const ETAPA_EXECUCAO = 4;
export const ETAPA_ENTREGA = 5;
export const ETAPA_FINALIZADO = 6;
export const ETAPA_CANCELADO = 7;
export const ETAPA_DEVOLVIDO = 8;

export const ETAPAS: EtapasId[] = [
    ETAPA_ABERTO,
    ETAPA_PENDENTE,
    ETAPA_APROVADO,
    ETAPA_EXECUCAO,
    ETAPA_ENTREGA,
    ETAPA_FINALIZADO,
    ETAPA_CANCELADO,
    ETAPA_DEVOLVIDO,
];

export const ETAPAS_FINAIS = [ETAPA_FINALIZADO, ETAPA_CANCELADO, ETAPA_DEVOLVIDO];

export const ETAPAS_EM_ANDAMENTO = [ETAPA_PENDENTE, ETAPA_EXECUCAO, ETAPA_ENTREGA];

export const ETAPAS_IMPRIMIR_PEDIDO = [ETAPA_EXECUCAO, ETAPA_ENTREGA];

export const ETAPAS_PODE_EDITAR_PEDIDO = [ETAPA_PENDENTE, ETAPA_EXECUCAO];

export const NOMES_ETAPAS: { [EtapasId]: string} = {
    [ETAPA_ABERTO]: 'Aberto',
    [ETAPA_PENDENTE]: 'Pendente',
    [ETAPA_APROVADO]: 'Aprovado',
    [ETAPA_EXECUCAO]: 'Execução',
    [ETAPA_ENTREGA]: 'Entrega',
    [ETAPA_FINALIZADO]: 'Finalizado',
    [ETAPA_CANCELADO]: 'Cancelado',
    [ETAPA_DEVOLVIDO]: 'Devolvido',
};

export const ETAPAS_GRID = [
    ETAPA_PENDENTE,
    ETAPA_APROVADO,
    ETAPA_EXECUCAO,
    ETAPA_ENTREGA,
    ETAPA_FINALIZADO,
    ETAPA_CANCELADO,
    ETAPA_DEVOLVIDO,
];

export const NIVEL_URGENTE = 2;
export const NIVEL_ATENCAO = 1;
export const NIVEL_NORMAL = 0;
export const MINUTOS_ATENCAO = 15;
export const MINUTOS_URGENTE = 30;
